import React from "react";

import { Box } from "@mui/material";
import "../BrandMetadataReview.css";
import BrandReviewInstructions from "../UI/BrandReviewInstructions";

import ParentBrandsbyBrandTable from "../Reports/ParentBrandsbyBrandTable";
interface BrandMetadataReviewProps {
  brand_id: string;
}

const ReviewBrandParents: React.FC<BrandMetadataReviewProps> = ({
  brand_id,
}) => {
  const user_instructions = {
    section_id: "brand-parents",
    instruction_title: "Review Parent Brand",
    purpose:
      "The `ownership_parent_id` is an attribute that identifies the parent brand when a brand is owned by a larger corporation.\n\nThis relationship helps track brand hierarchies and corporate ownership. For instance, it can show relationships like Amazon Fresh being owned by Amazon, or KFC being owned by Yum! Brands.\n\nThe `ownership_parent_id` is different from location relationships - it specifically tracks brand ownership rather than physical location relationships.",
    goal: "Ensure all countries where the brand operates are accurately reflected in the metadata.",
    task_description:
      "Validate the parent brand in the `ownership_parent_id` attribute from the metadata.",
    task_steps: [
      {
        title: "Validate Parent Brand",
        instructions: [
          "If a parent brand exists validate that the parent brand is accurate.",
          "If a parent brand does not exist, research and identify whether the brand should be associated with a parent brand.",
        ],
      },
      {
        title: "Update Metadata",
        instructions: [
          {
            text: "If updates are required (either removing or adding a brand ID), modify the `ownership_parent_id` attribute in `Kuebiko` to reflect the correct parent brand ID value (or null value).",
            sublist: [
              "Navigate to the brand in `Kuebiko`.",
              "Select `Brand Edit`.",
              "Update the `ownership_parent_id` field with the correct parent brand ID or null value.",
            ],
          },
        ],
      },
    ],
  };

  return (
    <Box className="metadata-review-container">
      <BrandReviewInstructions {...user_instructions} />
      <ParentBrandsbyBrandTable brand_id={brand_id} />
    </Box>
  );
};

export default ReviewBrandParents;
